import { createEntityAdapter, EntityState } from "@magicware/redux/entities";
import { anchoreThunks, AsyncSliceState } from "@magicware/redux/thunks";
import { createSlice } from "@reduxjs/toolkit";
import {
    entityApi,
    ApiServerInstanceModelDetail,
    ApiServerInstanceFilter,
    ApiServerInstanceModelList,
} from "../../services/api/apiServerInstances";
import { RootState } from "../types";

export interface State
    extends EntityState<ApiServerInstanceModelDetail, ApiServerInstanceModelList, ApiServerInstanceFilter>,
        AsyncSliceState {}

const initialState: State = { async: {} };

const adapter = createEntityAdapter("apiServerInstances", entityApi, ["name"]);

const extraThunks = {};

const slice = createSlice({
    name: "apiServerInstances",
    initialState,
    reducers: adapter.getReducers(),
    extraReducers: (builder) => {
        adapter.addExtraReducers(builder);
        //addAsyncThunkReducers(builder, extraThunks.xxx);
    },
});

export const apiServerInstanceThunks = anchoreThunks((state: RootState) => state.apiServerInstances, {
    ...extraThunks,
    ...adapter.thunks,
});

export const actions = slice.actions;
export const { updateDetail, clearList, removeListItems, updateListItems, setPage } = slice.actions;
export default slice.reducer;
